import axios from "axios";
import store from "../store";

// N2.0
const httpClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}`,
  timeout: 5000,
  withCredentials: true,
  headers: {
    // requires Cache-Control for IE11 GET requests, otherwise they are not fetched again
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});
httpClient.defaults.cache = false;
httpClient.interceptors.request.use(function(config) {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});
// N1.0
const instance = axios.create({
  baseURL: `${process.env.VUE_APP_NIOTA_URL}${process.env.VUE_APP_N1_API_PATH}`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    // requires Cache-Control for IE11 GET requests, otherwise they are not fetched again
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
});
instance.defaults.cache = false;
instance.interceptors.request.use(function(config) {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

export default {
  // ####### N2.0 ########
  verify() {
    return httpClient.get("/auth/verify");
  },
  login(userData) {
    return httpClient
      .post(`/auth/login`, userData)
      .then((response) => {
        const token = response.data.token;
        httpClient.defaults.headers.common["Authorization"] = token;
        instance.defaults.headers.common["Authorization"] = token;
        localStorage.setItem("token", token);
        return response.data;
      })
      .catch((response) => {
        this.logout();
        localStorage.removeItem("token");
        delete httpClient.defaults.headers.common["Authorization"];
        delete instance.defaults.headers.common["Authorization"];
        response.error = response;
        return response;
      });
  },
  logout() {
    localStorage.removeItem("token");
    store.state.account = null;
    store.state.user = null;
    store.state.accountId = null;
    return httpClient.get("/auth/logout").finally(() => {
      delete httpClient.defaults.headers.common["Authorization"];
      delete instance.defaults.headers.common["Authorization"];
    });
  },
  updateUser(user) {
    return httpClient.put(`/user/${user.id}`, user);
  },
  getTenantPasswordPolicy(tenantId) {
    return httpClient
      .get(`/tenant/passwordpolicy/tenant/${tenantId ? tenantId : ""}`)
      .then((response) => {
        return response.data;
      });
  },
  validateUserPassword(password, tenantId, passwordToken) {
    return httpClient
      .post("/user/passwordpolicy/validate", {
        password,
        tenantId,
        passwordToken,
      })
      .then((response) => {
        return response.data;
      });
  },
  updatePassword(userId, password, newPassword) {
    return httpClient.put(`/user/${userId}/password`, {
      password,
      newPassword,
    });
  },
  // ####### N1.0 ########
  updateAccount(account) {
    return instance
      .put(`/account/${account.id}`, account)
      .then((res) => res.data);
  },
  getAccountIntegrations(context, accountId) {
    context.$loader.startLoading("getAccountIntegrations");
    return instance
      .get(`/account/${accountId}/integrations`)
      .then((response) => {
        context.$loader.endLoading("getAccountIntegrations");
        return response.data.data.integrations;
      })
      .catch((response) => {
        context.$loader.endLoading("getAccountIntegrations");
        return response;
      });
    // .finally(() => {
    //   context.$loader.endLoading('getAccountIntegrations')
    // })
  },

  getApplications(context) {
    context.$loader.startLoading("getApplications");
    return instance
      .get(`/applications/plain`)
      .then((response) => {
        let applications = response.data.data.applications;

        applications.forEach((application) => {
          application.image = `${process.env.VUE_APP_NIOTA_URL}${
            application.image
          }`;
          application.hidden = false;
        });
        context.$loader.endLoading("getApplications");
        return applications;
      })
      .catch((response) => {
        context.$loader.endLoading("getApplications");
        return response;
      });
    // .finally(() => {
    //   context.$loader.endLoading('getApplications')
    // })
  },

  getApplicationDevices(context, applicationId) {
    context.$loader.startLoading("getApplicationDevices");
    return instance
      .get(`/application/${applicationId}/devices/plain`)
      .then((response) => {
        context.$loader.endLoading("getApplicationDevices");
        return response.data.data.devices;
      })
      .catch((response) => {
        context.$loader.endLoading("getApplicationDevices");
        return response;
      });
  },

  getDevice(context, deviceId) {
    context.$loader.startLoading("getDevice");
    return instance
      .get(`/device/${deviceId}`)
      .then((response) => {
        context.$loader.endLoading("getDevice");
        return response.data.data.device;
      })
      .catch((response) => {
        context.$loader.endLoading("getDevice");
        return response;
      });
  },

  getDevicePackets(context, deviceId, limit = 50) {
    context.$loader.startLoading("getDevicePackets");
    return instance
      .get(`/device/${deviceId}/packets?limit=${limit}`)
      .then((response) => {
        context.$loader.endLoading("getDevicePackets");
        return response.data.data.packets;
      })
      .catch((response) => {
        context.$loader.endLoading("getDevicePackets");
        return response;
      });
    // .finally(() => {
    //   context.$loader.endLoading('getDevicePackets')
    // })
  },

  findDevices(context, query) {
    context.$loader.startLoading("findDevices");
    return instance
      .get(`/devices/find/${query}?limit=10`)
      .then((response) => {
        context.$loader.endLoading("findDevices");
        return response.data.data.devices;
      })
      .catch((response) => {
        context.$loader.endLoading("findDevices");
        return response;
      });
    // .finally(() => {
    //   context.$loader.endLoading('findDevices')
    // })
  },

  verifyTwoFactorCode(context, code) {
    context.$loader.startLoading("verifyTwoFactorCode");
    return instance
      .post(`/user/two-factor/verify`, {
        code,
      })
      .then((response) => {
        context.$loader.endLoading("verifyTwoFactorCode");
        return response.data.verified;
      })
      .catch((response) => {
        response.error = response;
        context.$loader.endLoading("verifyTwoFactorCode");
        return response;
      });
    // .finally(() => {
    //   context.$loader.endLoading('verifyTwoFactorCode')
    // })
  },

  updateUserInfo(context, userId, data) {
    context.$loader.startLoading("updateUserInfo");
    let req = {
      url: `${process.env.VUE_APP_NIOTA_URL}/api/user/${userId}`,
      method: "PUT",
      data: data,
      withCredentials: true,
    };
    return axios(req)
      .then((response) => {
        context.$loader.endLoading("updateUserInfo");
        return response;
      })
      .catch((response) => {
        response.error = response;
        response.error.msg = response.response.data.err;
        context.$loader.endLoading("updateUserInfo");
        return response;
      });
  },

  getAccount(context, accountId) {
    context.$loader.startLoading("processMenuData");
    return instance
      .get(`/account/${accountId}`)
      .then((response) => {
        context.$loader.endLoading("processMenuData");
        return response.data.data.account;
      })
      .catch((response) => {
        response.error = response;
        context.$loader.endLoading("processMenuData");
        return response;
      });
  },

  // updateAccount(context, account) {
  //   context.$loader.startLoading("saveMenuData");

  //   let req = {
  //     url: `${process.env.VUE_APP_NIOTA_URL}/api/account/${account.id}`,
  //     method: "PUT",
  //     data: account,
  //     withCredentials: true,
  //   };
  //   return axios(req)
  //     .then(response => {
  //       context.$loader.endLoading("saveMenuData");
  //       return response;
  //     })
  //     .catch(response => {
  //       response.error = response;
  //       context.$loader.endLoading("saveMenuData");
  //       return response;
  //     });
  // },

  changePassword(context, userId, data) {
    context.$loader.startLoading("changePassword");
    let req = {
      url: `${process.env.VUE_APP_NIOTA_URL}/api/user/${userId}/password`,
      method: "PUT",
      data: data,
      withCredentials: true,
    };
    return axios(req)
      .then((response) => {
        context.$loader.endLoading("changePassword");
        return response;
      })
      .catch((response) => {
        response.error = response;
        response.error.msg = response.response.data.err;
        context.$loader.endLoading("changePassword");
        return response;
      });
  },

  getPasswordConfig(context, accountId) {
    context.$loader.startLoading("passwordConfig");
    return instance
      .get(`/account/password-config/${accountId}&user`)
      .then((response) => {
        context.$loader.endLoading("passwordConfig");
        return response.data.data.pwconfig;
      })
      .catch((response) => {
        context.$loader.endLoading("passwordConfig");
        return response;
      });
  },

  getParsedPackets(deviceId, body) {
    return instance
      .post(`/device/${deviceId}/parsed-packets`, body)
      .then((response) => {
        return response.data.data;
      })
      .catch((response) => {
        response.error = response;
        return response;
      });
    // eslint-disable-next-line
  },
};
